/* eslint-disable react/prop-types */
import { EyeOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Spin,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import FormSubmitControls from 'components/FormSubmitControls';
import Previewer from 'components/Previewer';
import Select from 'components/Select';
import Table from 'components/Table';
import Uploader from 'components/Uploader';
import React, { useEffect, useState } from 'react';
import { formatReceived } from 'utils/formatValues';
import { onError } from 'utils/handlers';

import {
  getDocumentoEmpleado,
  getDocumentosEmpleadosParams,
  patchDocumentoEmpleado,
  postDocumentoEmpleado,
  putDocumentosEmpleadoStatus,
} from 'api/catalogos/documentosEmpleados';
import { getTiposDeDocumentos } from 'api/catalogos/tiposDeDocumentos';
import {
  patchEstadoEmpleado,
} from 'api/estructuraOrganizacional/empleados';
import { checkToken } from 'api/utils';
import { ESTADO_ACTIVO, ESTADO_PRE_ALTA } from 'utils/constants';

export const documentoEmpleadoPermission = {
  permissionModel: 'documentoempleado',
  catalogsModels: [],
  tabsModels: [],
};

const Documentos = ({
  empleadoId,
  rules,
  formEmpleado,
  permission,
  isBlocked,
  actualizarTablaEmpleados,
}) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [tiposDeDocumentos, setTiposDeDocumentos] = useState([]);
  const [tipoDeDocumento, setTipoDeDocumento] = useState();
  const [documentosEmpleados, setDocumentosEmpleados] = useState([]);
  const [currentTableData, setCurrentTableData] = useState([]);
  const [currentFile, setCurrentFile] = useState();
  const [visiblePreview, setVisiblePreview] = useState(false);
  // const [previewUrl, setPreviewUrl] = useState('');
  // const [isImage, setIsImage] = useState(false);
  const formInstances = [
    form,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getDocumentosEmpleadosParams({ empleado: empleadoId });
    setDocumentosEmpleados(_data);
    setLoading(false);
    return _data;
  };

  const updateEstadoDelEmpleado = async () => {
    const _documentos = await fetchData();
    const _documentosEntregados = _documentos.filter((e) => e.entregado === true);
    const { estado_del_empleado } = formEmpleado.getFieldsValue();

    // 2. HACEMOS LA VALIDACIÓN DINÁMICA
    const todosEntregados = _documentosEntregados.length === _documentos.length;

    if (estado_del_empleado === ESTADO_PRE_ALTA && todosEntregados) {
      const response = await patchEstadoEmpleado(empleadoId, ESTADO_ACTIVO);
      if (response) {
        formEmpleado.setFieldValue('estado_del_empleado', ESTADO_ACTIVO);

        // 3. DISPARAMOS LA RECARGA EN EL PADRE
        if (actualizarTablaEmpleados) actualizarTablaEmpleados();
      }
    }

    if (estado_del_empleado === ESTADO_ACTIVO && !todosEntregados) {
      const reponse = await patchEstadoEmpleado(empleadoId, ESTADO_PRE_ALTA);
      if (reponse) {
        formEmpleado.setFieldValue('estado_del_empleado', ESTADO_PRE_ALTA);

        // 3. DISPARAMOS LA RECARGA EN EL PADRE
        if (actualizarTablaEmpleados) actualizarTablaEmpleados();
      }
    }
  };

  useEffect(() => {
    let mounted = true;
    if (!empleadoId) {
      setDocumentosEmpleados([]);
      return undefined;
    }
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _tiposDeDocumentos,
        _documentosEmpleados,
      ] = await Promise.all([
        getTiposDeDocumentos(),
        getDocumentosEmpleadosParams({ empleado: empleadoId }),
      ]);
      if (mounted) {
        setTiposDeDocumentos(_tiposDeDocumentos);
        setDocumentosEmpleados(_documentosEmpleados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, [empleadoId]);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    form.resetFields();
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || documentosEmpleados.find((item) => item.id === key);
    const _documentoEmpleado = await getDocumentoEmpleado(match.id);
    // eslint-disable-next-line max-len
    const _tipoDeDocumento = tiposDeDocumentos.find((e) => e.id === _documentoEmpleado?.tipo_de_documento)?.nombre;
    setTipoDeDocumento(_tipoDeDocumento);
    setTimeout(() => {
      if (_documentoEmpleado) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(_documentoEmpleado));
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchDocumentoEmpleado(key, values) : postDocumentoEmpleado(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
          await updateEstadoDelEmpleado();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const onClickTrue = async () => {
    try {
      setLoading(true);
      const mappedSelectedRowKeys = selectedRowKeys.map((val) => ({
        empleado_id: empleadoId, id: val, entregado: true,
      }));
      const saved = await putDocumentosEmpleadoStatus(mappedSelectedRowKeys);
      if (saved) {
        await fetchData();
        onCancel();
      }
      await updateEstadoDelEmpleado();
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
    setLoading(false);
  };

  const onClickFalse = async () => {
    try {
      setLoading(true);
      const mappedSelectedRowKeys = selectedRowKeys.map((val) => ({
        empleado_id: empleadoId, id: val, entregado: false,
      }));
      const saved = await putDocumentosEmpleadoStatus(mappedSelectedRowKeys);
      if (saved) {
        await fetchData();
        onCancel();
      }
      await updateEstadoDelEmpleado();
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
    setLoading(false);
  };
  const onClickPreview = () => {
    const clone = [...documentosEmpleados];
    const [key] = selectedRowKeys;
    const match = clone.find((e) => e.id === key);
    setCurrentFile(match);
    setVisiblePreview(true);
  };

  const handleOnRowClick = (record) => {
    if (selectedRowKeys.includes(record.id)) {
      setSelectedRowKeys(selectedRowKeys.filter((key) => key !== record.id));
    } else {
      setSelectedRowKeys([...selectedRowKeys, record.id]);
      form.setFieldsValue(record);
    }
  };
  /*
  const handlePreview = (archivo) => {
    setPreviewUrl(archivo);
    setIsImage(archivo.includes('.jpg') || archivo.includes('.png') || archivo.includes('.jpeg'));
    setPreviewVisible(true);
  };

  const handleFileChange = () => {
    const archivo = form.getFieldValue('Documento_uploader');

    if (archivo && archivo.length > 0) {
      setDocumentosEmpleados((prev) => ({
        ...prev,
        archivo: archivo[0], // Guardamos el primer archivo
      }));
    } else {
      setDocumentosEmpleados((prev) => ({ ...prev, archivo: null }));
    }
  }; */

  const handleSelectAll = (selected) => {
    if (selected) {
      const source = currentTableData.length ? currentTableData : documentosEmpleados;
      setSelectedRowKeys(source.map((row) => row.id));
    } else {
      setSelectedRowKeys([]);
    }
  };

  const handleTableChange = (_pagination, _filters, _sorter, extra) => {
    if (extra?.currentDataSource) {
      setCurrentTableData(extra.currentDataSource);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onSelectAll: handleSelectAll,
    type: 'checkbox',
  };

  const esImagen = (file) => {
    if (!file || !file.archivo) return false; // Si no hay archivo, no es imagen
    const extensionRegex = /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/i;
    const mimeTypeRegex = /^image\//;

    return mimeTypeRegex.test(file.type) || extensionRegex.test(file.archivo);
  };

  const getFileUrl = () => {
    if (!currentFile?.archivo) return null;
    if (currentFile.archivo.includes('?')) return currentFile.archivo;
    return `${currentFile.archivo}?t=${new Date().getTime()}`;
  };
  const fileUrl = getFileUrl();

  const columns = [
    {
      titleText: 'Documento',
      dataIndex: 'tipo_de_documento',
      key: 'tipo_de_documento',
      width: 300,
      render: (val) => tiposDeDocumentos.find((e) => e.id === val)?.nombre,
    },
    {
      titleText: 'Tipo',
      dataIndex: 'version_del_documento',
      key: 'version_del_documento',
      width: 200,
      render: (val) => {
        if (val === 1) return 'Copia';
        if (val === 2) return 'Original';
        return 'Desconocido';
      },
    },
    {
      titleText: 'Entregado por el Empleado',
      dataIndex: 'entregado',
      key: 'entregado',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 200,
    },
    /*
    {
      title: 'Archivo',
      dataIndex: 'archivo',
      key: 'archivo',
      render: (archivo) => (
        <Button type="link" onClick={() => handlePreview(archivo)}>
          Preview
        </Button>
      ),
    }, */
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          customActions={[
            {
              onClick: onClickTrue,
              text: 'Marcar como Entregado',
              type: 'primary',
              disabled: !selectedRowKeys.length,
            },
            {
              onClick: onClickFalse,
              text: 'Marcar como no Entregado',
              danger: true,
              disabled: !selectedRowKeys.length,
            },
            {
              onClick: onClickPreview,
              icon: <EyeOutlined />,
              text: 'Ver Documento',
              disabled: !selectedRowKeys.length,
            },
          ]}
          cols={columns}
          data={documentosEmpleados}
          rowSelection={rowSelection}
          onTableChange={handleTableChange}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickEdit: () => onClickEdit(),
            onClickTrue: () => onClickTrue(),
            onClickFalse: () => onClickFalse(),
          }}
          allowMultiFalseChanger={false}
          allowMultiTrueChanger={false}
          allowDoubleClick={false}
          permission={permission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Documento`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
            />
          )}
          onCancel={onCancel}
          forceRender
          width="35%"
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="nombre"
                  label="Nombre de Documentos"
                >
                  <Input
                    disabled
                    defaultValue={tipoDeDocumento}
                  />
                </Form.Item>
                <Form.Item
                  name="entregado"
                  label="Entregado Por El Empleado"
                  rules={rules.required}
                  initialValue={false}
                >
                  <Select
                    trueFalse
                    disabled={isBlocked}
                  />
                </Form.Item>
                <Uploader
                  title="Documento"
                  limitMB={5}
                  file={form.getFieldValue('archivo')}
                  formItemName="archivo"
                  allowedExtensions={['jpg', 'png', 'jpeg', 'pdf']}
                  rules={rules.required}
                  allowPreview={false}
                />

                <Form.Item
                  name="observaciones"
                  label="Observaciones"
                >
                  <TextArea
                    rows={3}
                    allowClear
                    disabled={isBlocked}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
        <Previewer
          open={visiblePreview}
          setVisible={setVisiblePreview}
          iFrameUrl={fileUrl}
          isImage={esImagen(currentFile)}
        />
      </Spin>
    </Row>
  );
};

export default Documentos;
